import { render, staticRenderFns } from "./DashboardNoCredit.vue?vue&type=template&id=8a8de46e"
import script from "./DashboardNoCredit.vue?vue&type=script&lang=js"
export * from "./DashboardNoCredit.vue?vue&type=script&lang=js"
import style0 from "./DashboardNoCredit.vue?vue&type=style&index=0&id=8a8de46e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports